import { Component, Input } from '@angular/core';
import { EditerFichePropriete } from '../../propriete.state';
import { Store } from '@ngxs/store';
import { DonneReferenceService } from '../../../shared/services/donne-reference.service';
import { ProprieteModele } from '../../modeles/proprieteModel';

@Component({
  selector: 'app-property-details-old-info',
  templateUrl: './property-details-old-info.component.html',
  styleUrls: ['./property-details-old-info.component.scss'],
  standalone: false
})
export class PropertyDetailsOldInfoComponent {
  @Input()
  currentProperty: ProprieteModele;

  constructor(private readonly _store: Store, private readonly _donneeReferencesService: DonneReferenceService) {}

  editProperty(): void {
    this._store.dispatch(
      new EditerFichePropriete(this.currentProperty.id, 'propriete/detail/' + this.currentProperty.id)
    );
  }

  get type() {
    const object = this._donneeReferencesService.getTypeProprieteeSelected(this.currentProperty.type, 'propertyID');
    return object && object['typeProprietee'] ? object['typeProprietee'] : '';
  }

  get adresse() {
    const adresse = this.currentProperty.proprieteAdresse;
    if (adresse) {
      return adresse.adresseFormattee
        .replace(adresse.ville.toUpperCase(), adresse.ville)
        .substr(0, adresse.adresseFormattee.lastIndexOf(',')); // Enlever le pays
    } else {
      return '';
    }
  }
}
